import { NgModule, SkipSelf, Optional, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule, SETTINGS } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireFunctionsModule, ORIGIN } from '@angular/fire/functions';

import { AuthService } from './auth/auth.service';
import { UserServiceConfig } from './config/user-service-config';
import { AuthGuard } from './auth/auth-guard';
import { HttpInterceptorInterceptor } from './http/http-interceptor.interceptor';

import { JwtModule } from '@auth0/angular-jwt';
import { StoreModule, ActionReducer, MetaReducer } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { localStorageSync } from 'ngrx-store-localstorage';
import { coreReducer } from './state/core.state';
import * as cryptojs from 'crypto-js';
import { CacheInterceptor } from './cache/cache-interceptor.interceptor';
import firebaseConfig from 'src/assets/config/firebase';
@NgModule({
  imports: [
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAnalyticsModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('token');
        },
      },
    }),
    StoreModule.forRoot(coreReducer),
    StoreDevtoolsModule.instrument({maxAge: 25, logOnly: true}),
  ],
  providers: [
    AuthService,
    UserServiceConfig,
    AuthGuard,
    { provide: SETTINGS, useValue: {} },
    { provide: ORIGIN, useValue: environment.apiUrl },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorInterceptor, multi: true },
  ],
  declarations: []
})
export class InovantiBankCoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: InovantiBankCoreModule
  ) {
    if (parentModule) {
      throw new Error('InovantiBankCoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(config: UserServiceConfig): ModuleWithProviders<InovantiBankCoreModule> {
    return {
      ngModule: InovantiBankCoreModule,
      providers: [
        { provide: UserServiceConfig, useValue: config }
      ]
    };
  }
}
